import React from 'react';

export function Dialog({ open = true, title, children, onClose, actions = null, style = {} }) {
  const panelRef = React.useRef(null);

  React.useEffect(() => {
    if (!open) return;
    const prev = document.activeElement;
    panelRef.current?.focus();
    const onKey = (e) => {
      if (e.key === 'Escape' && onClose) onClose();
    };
    window.addEventListener('keydown', onKey);
    return () => {
      window.removeEventListener('keydown', onKey);
      if (prev instanceof HTMLElement) prev.focus();
    };
  }, [open, onClose]);

  if (!open) return null;
  return (
    <div
      role="presentation"
      onClick={onClose}
      style={{
        position: 'fixed', inset: 0, background: 'var(--surface-overlay)',
        display: 'flex', alignItems: 'flex-end', justifyContent: 'center',
        padding: 16, zIndex: 1000, backdropFilter: 'blur(2px)',
      }}
    >
      <div
        ref={panelRef}
        role="dialog"
        aria-modal="true"
        aria-labelledby={title ? 'kor-dialog-title' : undefined}
        tabIndex={-1}
        onClick={(e) => e.stopPropagation()}
        style={{
          width: '100%', maxWidth: 'var(--screen-max)',
          background: 'var(--surface-card)', borderRadius: 'var(--radius-2xl)',
          padding: 'var(--space-6)', boxShadow: 'var(--shadow-lg)',
          animation: 'kor-rise var(--dur-slow) var(--ease-out)',
          marginBottom: 'env(safe-area-inset-bottom, 8px)', ...style,
        }}
      >
        <div style={{ width: 40, height: 4, borderRadius: 2, background: 'var(--sand-300)', margin: '0 auto 18px' }} />
        {title && <h3 id="kor-dialog-title" style={{ margin: '0 0 8px', fontFamily: 'var(--font-display)', fontSize: 'var(--text-xl)', fontWeight: 'var(--weight-bold)', color: 'var(--text-primary)' }}>{title}</h3>}
        <div style={{ fontSize: 'var(--text-md)', color: 'var(--text-secondary)', lineHeight: 'var(--leading-normal)' }}>{children}</div>
        {actions && <div style={{ display: 'flex', gap: 12, marginTop: 24 }}>{actions}</div>}
      </div>
    </div>
  );
}
